import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-73a4612e")

_pushScopeId("data-v-73a4612e")
const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "\n          d-flex\n          flex-wrap-reverse\n          align-items-end\n          justify-content-between\n          text-nowrap\n        " }
const _hoisted_3 = { class: "flex-column me-4" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "mb-4 d-flex" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "row mt-5" }
const _hoisted_9 = { class: "col-md" }
const _hoisted_10 = { class: "col-md" }
const _hoisted_11 = { value: "ORGANIZATION" }
const _hoisted_12 = { value: "USER" }
const _hoisted_13 = { class: "mt-5 p-5 bg-info flex-grow-1" }
const _hoisted_14 = { class: "d-flex align-items-start mb-2" }
const _hoisted_15 = { class: "d-flex flex-column" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_pretty_bar = _resolveComponent("pretty-bar")!
  const _component_VDButton = _resolveComponent("VDButton")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_select = _resolveComponent("o-select")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Error = _resolveComponent("Error")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_RolePicker = _resolveComponent("RolePicker")!
  const _component_sidebar = _resolveComponent("sidebar")!

  return (_openBlock(), _createBlock(_component_sidebar, {
    class: "bg-white d-flex flex-column",
    isLoading: _ctx.loading,
    error: _ctx.error
  }, {
    default: _withId(() => [
      _createVNode(_component_ConfirmPopup, {
        group: "sidebar",
        appendTo: "#sidebar"
      }),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_pretty_bar),
            _createVNode("h2", null, _toDisplayString(_ctx.isNew ? _ctx.$translate("TextResources_CreateProfile") : _ctx.profile?.name), 1),
            _createVNode("h4", _hoisted_4, _toDisplayString(_ctx.profile?.application?.name), 1)
          ]),
          _createVNode("div", _hoisted_5, [
            (!_ctx.isNew)
              ? (_openBlock(), _createBlock("span", _hoisted_6, [
                  _createVNode(_component_VDButton, {
                    variant: "danger",
                    class: "me-2",
                    icon: "trash",
                    onClick: _ctx.deleteProfile,
                    isLoading: _ctx.deleteProfileMutation.loading.value
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$translate("TextResources_DeleteProfile")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "isLoading"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isNew || _ctx.hasChanges)
              ? (_openBlock(), _createBlock(_component_VDButton, {
                  key: 1,
                  icon: "check",
                  onClick: _ctx.onPrimaryButton,
                  isLoading: _ctx.primaryButtonLoading
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.isNew
                ? _ctx.$translate("TextResources_Create")
                : _ctx.$translate("TextResources_SaveChange")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "isLoading"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.profile)
          ? (_openBlock(), _createBlock("form", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_o_field, {
                    variant: _ctx.v$.name.$error ? 'danger' : '',
                    label: `${_ctx.$translate('TextResources_ProfileName')} *`
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_o_input, {
                        ref: "nameInput",
                        modelValue: _ctx.profile.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.profile.name = $event)),
                        maxlength: "200"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["variant", "label"])
                ]),
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_o_field, {
                    label: `${_ctx.$translate('TextResources_LevelOfUse')} *`
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_o_select, {
                        modelValue: _ctx.profile.levelOfUse,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.profile.levelOfUse = $event)),
                        placeholder: "Vælg anvendelsesniveau",
                        class: "w-100",
                        disabled: !_ctx.isNew
                      }, {
                        default: _withId(() => [
                          _createVNode("option", _hoisted_11, _toDisplayString(_ctx.$translate("TextResources_LevelOfUse_Organization")), 1),
                          _createVNode("option", _hoisted_12, _toDisplayString(_ctx.$translate("TextResources_LevelOfUse_User")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]),
              _createVNode(_component_o_field, {
                class: "mt-3",
                label: _ctx.$translate('TextResources_Description')
              }, {
                default: _withId(() => [
                  _createVNode(_component_o_input, {
                    modelValue: _ctx.profile.description,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.profile.description = $event)),
                    type: "textarea",
                    maxlength: "250"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode("h2", null, _toDisplayString(_ctx.$translate("TextResources_Roles")), 1),
          _createVNode(_component_Button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.rolePicker?.toggle($event))),
            class: "ms-auto secondary"
          }, {
            default: _withId(() => [
              (_ctx.addRemoveLoading)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    class: "me-2",
                    spin: "",
                    icon: ['fas', 'spinner']
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" + " + _toDisplayString(_ctx.$translate("TextResources_Add")), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_DataTable, {
          stripedRows: true,
          responsiveLayout: "scroll",
          value: _ctx.profile?.roles,
          class: "text-start",
          selectionMode: "single"
        }, {
          empty: _withId(() => [
            _createVNode(_component_Error, {
              error: {
              title: _ctx.$translate('TextResources_EmptyRole'),
              message: _ctx.$translate('TextResources_EmptyRoleDescription'),
            }
            }, null, 8, ["error"])
          ]),
          default: _withId(() => [
            _createVNode(_component_Column, { field: "name" }, {
              body: _withId(({ data }) => [
                _createVNode("div", _hoisted_15, _toDisplayString(data.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              style: {"width":"1px","white-space":"nowrap"},
              field: "menu"
            }, {
              body: _withId(({ data }) => [
                _createVNode(_component_Button, {
                  class: "danger inverted",
                  onClick: ($event: any) => (_ctx.onRemovedRole(data))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'minus'] })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createVNode(_component_RolePicker, {
        disabled: _ctx.addRemoveLoading,
        ref: "rolePicker",
        addedRoles: (_ctx.profile?.roles || []).filter(role => role != null) as _ctx.RoleType[],
        application: _ctx.profile?.application || undefined,
        onAddedRole: _ctx.onAddedRole
      }, null, 8, ["disabled", "addedRoles", "application", "onAddedRole"])
    ]),
    _: 1
  }, 8, ["isLoading", "error"]))
})